import React, { useState, useEffect } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import { makeStyles } from "@material-ui/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import logo from "../../assets/LogoHomePage.PNG";

function ElevationScroll(props) {
  const { children } = props;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0
  });
}

const useStyles = makeStyles(theme => ({
  toolbarMargin: {
    ...theme.mixins.toolbar,
    marginBottom: "6em",
    [theme.breakpoints.down("md")]: {
      marginBottom: "2em"
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: "1.25em"
    }
  },
  logo: {
    height: "8em",
    [theme.breakpoints.down("md")]: {
      height: "7em"
    },
    [theme.breakpoints.down("xs")]: {
      height: "5.5em"
    }
  },
  logoContainer: {
    paddingLeft: "40px", // increased left padding for logo
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  tabContainer: {
    marginLeft: "auto",
    marginRight: "120px"  // added right margin to the tabs container
  },
  tab: {
    ...theme.typography.tab,
    minWidth: 10,
    marginLeft: "25px"
  },
  button: {
    ...theme.typography.estimate,
    borderRadius: "50px",
    marginLeft: "50px",
    marginRight: "25px",
    height: "45px",
    backgroundColor: theme.palette.secondary.main, // festive secondary color
    color: "#fff",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light
    }
  },
  menu: {
    backgroundColor: "#B71C1C", // Darker festive red
    color: "white",
    borderRadius: "0px"
  },
  menuItem: {
    ...theme.typography.tab,
    opacity: 0.7,
    "&:hover": {
      opacity: 1
    }
  },
  drawerIcon: {
    height: "50px",
    width: "50px"
  },
  drawerIconContainer: {
    marginLeft: "auto",
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  drawer: {
    backgroundColor: "#D32F2F", // Festive red color
    backgroundImage: "url('https://www.transparenttextures.com/patterns/snow.png')",
    backgroundRepeat: "repeat",
    backgroundSize: "contain",
  },
  drawerItem: {
    ...theme.typography.tab,
    color: "white",
    opacity: 0.7
  },
  drawerItemEstimate: {
    backgroundColor: theme.palette.common.orange
  },
  drawerItemSelected: {
    "& .MuiListItemText-root": {
      opacity: 1
    }
  },
  appbar: {
    zIndex: theme.zIndex.modal + 1,
    backgroundColor: "#D32F2F", // Festive red color
    backgroundImage: "url('https://www.transparenttextures.com/patterns/snow.png')",
    backgroundRepeat: "repeat",
    backgroundSize: "contain",
  },
}));

export default function Header(props) {
  const classes = useStyles();
  const theme = useTheme();
  const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const [openDrawer, setOpenDrawer] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
const [activeMenu, setActiveMenu] = useState(null); // Track which menu is active
const [anchorEl, setAnchorEl] = useState(null);

  const handleChange = (e, newValue) => {
    props.setValue(newValue);
  };

  const handleClick = (event, menuName) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(menuName);
    setOpenMenu(true);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
    setActiveMenu(null);
    setOpenMenu(false);
  };

  const handleMenuItemClick = (e, i) => {
    setAnchorEl(null);
    setOpenMenu(false);
    props.setSelectedIndex(i);
  };

 
  const menuOptions = [
    { name: "Kids", link: "/christmas-gift-ideas-for-kids", activeIndex: 1, selectedIndex: 0 },
    {
      name: "1 Year Old",
      link: "/christmas-gift-ideas-for-an-1-year-old",
      activeIndex: 1,
      selectedIndex: 1
    },
    {
      name: "2 Year Old",
      link: "/christmas-gift-ideas-for-an-2-year-old",
      activeIndex: 1,
      selectedIndex: 2
    },
    {
      name: "3 Year Old",
      link: "/christmas-gift-ideas-for-an-3-year-old",
      activeIndex: 1,
      selectedIndex: 3
    },
    {
      name: "4 Year Old",
      link: "/christmas-gift-ideas-for-an-4-year-old",
      activeIndex: 1,
      selectedIndex: 4
    },
    {
      name: "5 Year Old",
      link: "/christmas-gift-ideas-for-an-5-year-old",
      activeIndex: 1,
      selectedIndex: 5
    },
    {
      name: "6 Year Old",
      link: "/christmas-gift-ideas-for-an-6-year-old",
      activeIndex: 1,
      selectedIndex: 6
    },
    {
      name: "7 Year Old",
      link: "/christmas-gift-ideas-for-an-7-year-old",
      activeIndex: 1,
      selectedIndex: 7
    },
    {
      name: "8 Year Old",
      link: "/christmas-gift-ideas-for-an-8-year-old",
      activeIndex: 1,
      selectedIndex: 8
    },
    {
      name: "9 Year Old",
      link: "/christmas-gift-ideas-for-an-9-year-old",
      activeIndex: 1,
      selectedIndex: 9
    },

    {
      name: "Top Gifts",
      activeIndex: 6, // A new unique active index for this menu
      subMenu: [
        { name: "Top Gifts for Home Chefs This Christmas", link: "/top-gifts-for-home-chef-this-christmas", selectedIndex: 10 },
        { name: "Top Gifts for Cyclists This Christmas", link: "/top-gifts-for-cyclist-this-christmas", selectedIndex: 11 },
        { name: "Top Gifts for Tech DIY This Christmas", link: "/top-gifts-for-diy-enthusiasts-this-christmas", selectedIndex: 12 },
        { name: "Top Gifts for Home Office Workers This Christmas", link: "/top-gifts-for-home-office-worker-this-christmas", selectedIndex: 13 },
        { name: "Top Gifts for Tech Enthusiasts This Christmas", link: "/top-gifts-for-tech-enthusiasts-this-christmas", selectedIndex: 14 },
        { name: "Top Gifts for Outdoor Adventurers This Christmas", link: "/top-gifts-for-outdoor-adventurers-this-christmas", selectedIndex: 15 },
        

        
      ]
    },

  ];

  const routes = [
    { name: "Home", link: "/", activeIndex: 0 },
    { 
      name: "Kids", 
      link: "/christmas-gift-ideas-for-kids",
      activeIndex: 1,
      ariaOwns: activeMenu === "Kids" ? "kids-menu" : undefined,
      ariaPopup: activeMenu === "Kids" ? "true" : undefined,
      mouseOver: event => handleClick(event, "Kids")
    },
    { 
      name: "Top Gifts", 
      link: "#",
      activeIndex: 6,
      ariaOwns: activeMenu === "Top Gifts" ? "top-gifts-menu" : undefined,
      ariaPopup: activeMenu === "Top Gifts" ? "true" : undefined,
      mouseOver: event => handleClick(event, "Top Gifts")
    },
    { name: "Teens", link: "/christmas-gift-ideas-for-teens", activeIndex: 2 },
    { name: "Tweens", link: "/christmas-gift-ideas-for-tweens", activeIndex: 3 },
    { name: "Men", link: "/christmas-gift-ideas-for-men", activeIndex: 4 },
    { name: "Women", link: "/christmas-gift-ideas-for-women", activeIndex: 5 },
  ];

  useEffect(() => {
    [...menuOptions, ...routes].forEach(route => {
      switch (window.location.pathname) {
        case `${route.link}`:
          if (props.value !== route.activeIndex) {
            props.setValue(route.activeIndex);
            if (
              route.selectedIndex &&
              route.selectedIndex !== props.selectedIndex
            ) {
              props.setSelectedIndex(route.selectedIndex);
            }
          }
          break;
        
        default:
          break;
      }
    });
  }, [props.value, menuOptions, props.selectedIndex, routes, props]);

  const tabs = (
    <React.Fragment>
      <Tabs
        value={props.value}
        onChange={handleChange}
        className={classes.tabContainer}
        indicatorColor="primary"
      >
        {routes.map((route, index) => (
          <Tab
            key={`${route}${index}`}
            className={classes.tab}
            component={Link}
            to={route.link}
            label={route.name}
            aria-owns={route.ariaOwns}
            aria-haspopup={route.ariaPopup}
            onMouseOver={route.mouseOver}
          />
        ))}
      </Tabs>
      
     <Menu
  id="kids-menu"
  anchorEl={anchorEl}
  open={openMenu && activeMenu === "Kids"}
  onClose={handleClose}
  classes={{ paper: classes.menu }}
  MenuListProps={{ onMouseLeave: handleClose }}
  elevation={0}
  style={{ zIndex: 1500 }}  // Increased zIndex
  keepMounted
>
  {menuOptions
    .filter(option => option.activeIndex === 1) // Only show items for Kids
    .map((option, i) => (
      <MenuItem
        key={option.name}
        component={Link}
        to={option.link}
        classes={{ root: classes.menuItem }}
        onClick={event => {
          handleMenuItemClick(event, i);
          props.setValue(1);
          handleClose();
        }}
      >
        {option.name}
      </MenuItem>
    ))}
</Menu>

<Menu
  id="top-gifts-menu"
  anchorEl={anchorEl}
  open={openMenu && activeMenu === "Top Gifts"}
  onClose={handleClose}
  classes={{ paper: classes.menu }}
  MenuListProps={{ onMouseLeave: handleClose }}
  elevation={0}
  style={{ zIndex: 1500 }}  // Increased zIndex
  keepMounted
>
  {menuOptions
    .find(option => option.name === "Top Gifts")?.subMenu?.map(subOption => (
      <MenuItem
        key={subOption.name}
        component={Link}
        to={subOption.link}
        classes={{ root: classes.menuItem }}
        onClick={event => {
          handleMenuItemClick(event, subOption.selectedIndex);
          props.setValue(6);
          handleClose();
        }}
      >
        {subOption.name}
      </MenuItem>
    ))}
</Menu>


    </React.Fragment>
  );

  const drawer = (
    <React.Fragment>
      <SwipeableDrawer
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        onOpen={() => setOpenDrawer(true)}
        classes={{ paper: classes.drawer }}
      >
        <div className={classes.toolbarMargin} />
        <List disablePadding>
          {routes.map(route => (
            <ListItem
              divider
              key={`${route}${route.activeIndex}`}
              button
              component={Link}
              to={route.link}
              selected={props.value === route.activeIndex}
              classes={{ selected: classes.drawerItemSelected }}
              onClick={() => {
                setOpenDrawer(false);
                props.setValue(route.activeIndex);
              }}
            >
              <ListItemText className={classes.drawerItem} disableTypography>
                {route.name}
              </ListItemText>
            </ListItem>
          ))}
          
        </List>
      </SwipeableDrawer>
      <IconButton
        className={classes.drawerIconContainer}
        onClick={() => setOpenDrawer(!openDrawer)}
        disableRipple
      >
        <MenuIcon className={classes.drawerIcon} />
      </IconButton>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <ElevationScroll>
        <AppBar position="fixed" className={classes.appbar}>
          <Toolbar disableGutters>
            <Button
              component={Link}
              to="/"
              disableRipple
              onClick={() => props.setValue(0)}
              className={classes.logoContainer}
            >
              <img alt="company logo" className={classes.logo} src={logo} />
            </Button>
            {matches ? drawer : tabs}
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      <div className={classes.toolbarMargin} />
    </React.Fragment>
  );
}